<template>
  <div>
    <Edit_customer_point/>
  </div>
</template>

<script>
import Edit_customer_point from "@/components/adminArin/pos_system/customerpoint/Edit_customer_point";
export default {
  name: "editcustomerpoint",
  components: {
    Edit_customer_point
  }
}
</script>

<style scoped>

</style>
